import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';
import { User } from '../models/user';
import { environment } from '../../../environments/environment';
import { MemoryStorageService } from '../services/memory-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  skipURLs = [
    'register',
    'login',
    'resendotp',
    'polltruecallercheck',
    'verifyotp',
    'flightairportlist',
    'PartnerLogs',
    'getOurTeamOrPresence',
    'getTestimonialMedia',
    'airtable',
    'Otp',
    'CoreFactor',
    'sethotelsearch',
    'setflightsearch',
    'file.io',
    'travelplan',
    'ifsc.razorpay',
    'assistmodule/login/apiuser',
    'assistmodule/v1/signup',
    'assistmodule/v2/signup',
    'assistmodule/v1/submitotp',
    'assistmodule/v2/submitotp',
    'assistmodule/lenders/plan',
    'assistmodule/update/traveldetails',
    'otp/Sms',
    'assistmodule/v1/confirmpersonaldetails',
    //'PaymentGateway/Razorpay/GenerateOrder',
    'getpartnerlogo',
    'assistmodule/resendotp',
    'Menedo/getbanklist',
    //'menedo/checkmandate',
    //'menedo/updatemandatestatus',
    //'menedo/fetchmendatestatus'
    'assistmodule/UpdateAlternetNumber',
    'juspay/signup',
    'User/generate/token/',
    'User/getUserPlanDetailsforBSUpload',
    'tavusapi'
  ];

  constructor(private accountService: AccountService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var currentUser!: User;

    var urlfronSkipURLs = this.skipURLs.filter(x => {
      return request.url.includes(x) ? true : false;
    });

    if (urlfronSkipURLs.length <= 0) {

      if (this.accountService.currentUser$ != null) {
        this.accountService.currentUser$.subscribe(user => {
          currentUser = (user != null ? user : null)!;
        });
      }
      if (
        request.url.includes('assistmodule/v1/createUserProfile') ||
        request.url.includes('ProposedEMIPlans') ||
        request.url.includes('getcurrentapplicationstatusdesc') ||
        request.url.includes('GetLatestDocument') ||
        request.url.includes('assistmodule/uploadbusinessdetails')
        //|| request.url.includes('application/setApplStatusReasonHistories')        
      ) {
        const token = currentUser?.token || MemoryStorageService.getItem('partnerToken') || MemoryStorageService.getItem('accessToken');
        request = request.clone({
          setHeaders: {
            ...(token ? { Authorization: token.startsWith('Bearer ') ? token : ('Bearer ' + token) } : {}),
            'ApiKey': environment.PartnerapiKey,
            'PartnerId': environment.PartnerId
          },
          withCredentials: false,
        });
      }
      else if (request.url.includes('agent')) {
        request = request.clone({
          setHeaders: {
            'ApiKey': environment.PartnerapiKey,
            'PartnerId': environment.PartnerId
          },
          withCredentials: false,
        });
      }
      else {
        // Only set Authorization if not already provided on the request
        if (!request.headers.has('Authorization')) {
          const rawToken = currentUser?.token || 
                           MemoryStorageService.getItem('partnerToken') || 
                           MemoryStorageService.getItem('accessToken') || 
                           MemoryStorageService.getItem('customerToken');
          if (rawToken) {
            const tokenHeader = rawToken.startsWith('Bearer ') ? rawToken : ('Bearer ' + rawToken);
            request = request.clone({
              setHeaders: {
                Authorization: tokenHeader
              },
              withCredentials: false
            });
          }
        }
        console.log(request);
      }
    }
    return next.handle(request);
  }
}
